module.exports = __webpack_public_path__ + "img/background.598d499c.png";